export default {
  meta: {
    label: 'Norwegian'
  },
  data: {
    'nb-NO': {
      97: [['⚓️', 'anker'], ['🍍', 'ananas'], ['🚑', 'ambulanse'],['🐒', 'apekatt'], ['🦆', 'and']],
      98: [['🍌', 'banan'], ['👶', 'baby'], ['🐙', 'blekksprut'], ['🐝', 'bie'], ['🌊', 'bølge']],
      99: ['🇨🇦', 'canada'],
      100: [['💃', 'danse'], ['🍇', 'druer'], ['👸🏻', 'dronning'], ['👖', 'dongeribukse'], ['🐬', 'delfin'], ['🌺', 'blomst']],
      101: [['🦄', 'enhjørning'], ['🥚', 'egg'], ['🐘', 'elefant']],
      102: [['👣', 'føtter'], ['🦇', 'flaggermus'], ['🐸', 'frosk'], ['🇳🇴', 'flagg'], ['🎣', 'fiskestang']],
      103: [['🦍', 'gorilla'], ['🏐', 'garn'], ['🐖', 'gris']],
      104: [['🐶', 'hund'], ['🐹', 'hamster'], ['🐳', 'hval']],
      105: [['🍦', 'iskrem'], ['🔥', 'ild']],
      106: [['🕹️', 'joystick'], ['🌍', 'jordklode'], ['🎅', 'julenissen']],
      107: [['🐈', 'katt'], ['🐄', 'ku'], ['🔪', 'kniv'], ['🐇', 'kanin'], ['🦃', 'kalkun'], ['🛶', 'kano']],
      108: [['⚡️', 'lyn'], ['👩‍🏫', 'lærer']],
      109: [['🌝', 'måne'], ['👄', 'munn']],
      110: [['👃', 'nese'], ['🎶', 'noter'], ['🔑', 'nøkkel'], ['🇳🇴', 'norge']],
      111: [['👌', 'ok'], ['🧀', 'ost'], ['🐂', 'okse']],
      112: [['🥞', 'pannekaker'], ['🍐', 'pære'], ['☂️', 'paraply'], ['📫', 'postkasse'], ['🍿', 'popkorn']],
      113: [['🇶🇦', 'qatar']],
      114: [['👽', 'romvesen'], ['🌈', 'regnbue']],
      115: [['👻', 'spøkelse'], ['🥗', 'salat'], ['⭐️', 'stjerne'], ['❓', 'spørsmålstegn'], ['🐍', 'slange']],
      116: [['🐆', 'tiger'], ['🌮', 'taco'], ['🎲', 'terning']],
      117: [['🦉', 'ugle'], ['🛸', 'UFO']],
      118: [['🍉', 'vannmelon'], ['🌋', 'vulkan']],
      119: ['🏴󠁧󠁢󠁷󠁬󠁳󠁿󠁧󠁢󠁷󠁬󠁳󠁿', 'wales'],
      121: [['💴', 'yen'], ['☯️', 'yin og yang']],
      122: [['🧟', 'zombie'], ['🦓', 'zebra']]
    }
  }
};
